import Config from "../../env/config";
import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import "./PlanDetails.scss";
import MyContext from "../../Context/MainContext";
import Button from "../Button/Button";

const PlanDetails = ({
  isArabicLang,
  proposalCode,
  proposalData,
  onPayment,
  page,
  proposalloading,
  setModal,
}) => {
  const CDN_URL = Config.CDN_URL;
  const { contextValue } = useContext(MyContext);
  // console.log("contextValue",contextValue);
  const { addOns, prodData, policyType, serviceTax, totalPremium, orderData } =
    contextValue && contextValue.updatedPremiumDetails;
  const [lang] = useState(
    sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "en"
  );
  const { t, i18n } = useTranslation();
  useEffect(() => {
    changeLanguage(lang ? lang : sessionStorage.getItem("lang"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const params = useParams();
  const channel = params.channel;

  const isDomestic = () => {
    return params.insuranceType === "domestic-insurance";
  };

  const isTravel = () => {
    let travelChannels = ["tripsecureuat","branchtraveluat","tripsecure","branchtravel"];

    return travelChannels.includes(channel);
  };

  const updatedAddons =
    addOns && Array.isArray(addOns)
      ? addOns.filter(
          (addon) =>
            addon.addonCode !== "NA" &&
            addon.addonCode !== "" &&
            addon.addonCode !== null &&
            addon.addonCode !== undefined &&
            +addon.addonTotalPremium >= 0
        )
      : [];
  // console.log("prodData11",orderData,policyType,contextValue,prodData,addOns);
  const [isProductDetailsOpen, setProductDetailsOpen] = useState(false);
  const [isClassOpen, setClassOpen] = useState(true);
  const gotoSlideDown = () => {
    //alert('test');
    setProductDetailsOpen(true);
    setClassOpen(false);
  };

  const gotoSlideUp = () => {
    setProductDetailsOpen(false);
    setClassOpen(true);
  };

  return (
    <>
      {/* DESKTOP & TAB LEFT SECTION STARTS HERE  */}
      <div className="mobile-hidden">
        <div className="planDetailsMain">
          <div className="produtLogoName">
            <div className="ProductLogoItem">
              <img
                src={prodData?.images && prodData?.images[0]?.uri}
                alt="Product Logo Name"
              />
            </div>
            <div className="productName">
              <div className="productTitle">{prodData.name}</div>
            </div>
          </div>
          {policyType === "thirdparty" || isTravel() || isDomestic() ? null : (
            <div className="motor-plandetails-dts">
              <div className="plandetails-dts-itm">{t("VEHICLE_VALUE")}</div>
              <div className="plandetails-dts-itmrs text-right">
                RO{" "}
                {(+orderData?.vehicleDetails?.idv).toLocaleString("en-US", {
                  // currency: "USD",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{" "}
              </div>
            </div>
          )}
          {/* <div
            className="plandetails-dts">
            <div className="plandetails-dts-itm">{t("ADDON_TYPE_LABEL")}</div>
            <div className="plandetails-dts-itmrs text-right">{orderData?.vehicleDetails?.policyType}</div>
          </div> */}
          <div className="">
            {/* <div className="plandetails-dts-itm">{t("ADDON_LEFT_LABEL")} <i className="fas fa-info-circle"></i></div> */}
            {/* <div className="plandetails-dts-itmrs text-right"></div> */}
            {updatedAddons && updatedAddons.length > 0 && false
              ? updatedAddons?.map((addon) => (
                  <div
                    key={addon?.addonName}
                    className={
                      isArabicLang
                        ? "motor-plandetails-dts rgt-direction"
                        : "motor-plandetails-dts"
                    }
                  >
                    <div
                      className={
                        isArabicLang
                          ? "plandetails-dts-itm"
                          : "plandetails-dts-itm"
                      }
                    >
                      {addon?.addonName}
                    </div>
                    {+addon?.addonTotalPremium >= 0 ? (
                      <div
                        className={
                          isArabicLang
                            ? "plandetails-dts-itmrs text-left"
                            : "plandetails-dts-itmrs text-right"
                        }
                      >
                        {/* 2058 (AED) */}
                        RO{" "}
                        {(+addon?.addonTotalPremium).toLocaleString("en-US", {
                          // currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </div>
                    ) : null}
                  </div>
                ))
              : null}
              {
                false && 
                <div
                  className={
                    isArabicLang
                      ? "motor-plandetails-dts rgt-direction"
                      : "motor-plandetails-dts"
                  }
                >
                  <div
                    className={
                      isArabicLang ? "plandetails-dts-itm" : "plandetails-dts-itm"
                    }
                  >
                    Tax
                  </div>
                  <div
                    className={
                      isArabicLang
                        ? "plandetails-dts-itmrs text-left"
                        : "plandetails-dts-itmrs text-right"
                    }
                  >
                    {/* 2058 (AED) */}
                    RO{" "}
                    {(+serviceTax)?.toLocaleString("en-US", {
                      // currency: "USD",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </div>
                </div>

              }
          </div>
          <div className="planDetailsPrice">
            <div className="priceLabel"> {lang === "ar" ? "السعر" : "Premium" }</div>
            <div className="priceResult text-right">
              RO{" "}
              {(+totalPremium).toLocaleString("en-US", {
                // currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}{" "}
            </div>
          </div>
          {(channel === "opalmotoruat" || channel === "opal_motor_branch") && (
          <div className="opalSec">
            <div className="opalFlx">
              <div className="opalItem">
                <img
                  src={`${CDN_URL}opal_shakehand.webp`}
                  alt="shake hand"
                  title="shake hand"
                />
              </div>
              <div className="opalItem">
                <img
                  src={`${CDN_URL}precision_tune_auto_care.webp`}
                  alt="precision tune auto care"
                  title="precision tune auto care"
                />
              </div>
            </div>
           </div>
          )}
          {proposalloading ? (
            ""
          ) : page === "summary" ? (
            proposalCode == 0 && proposalData ? (
              <div className="desktop-hidden">
              <div className="planBtnSec">
                <Button
                  label={t("PAY_PROCEED_BTN")}
                  status={true}
                  isIcon={false}
                  // img={AllIcons.tickIcon}
                  clickFunction={onPayment}
                  buttonType="pay-proceed-btn"
                />
              </div>
              </div>
            ) : (
              // <div className="alertMsgFlx">
              //   <div className="alertInc">
              //     <i className="fa-solid fa-circle-exclamation"></i>
              //   </div>
              //   <div className="alertMsgTxt">
              //     <div className="msgTxtOne">Oops! Something went wrong.</div>
              //   </div>
              //   <div className="msgTxtTwo">
              //     Click <a onClick={setModal}>here</a> for details.Please reach
              //     out to our support team at support@tameen.om / 000 - tameen
              //     (0000000) for assistance. We’re here to help!
              //   </div>
              // </div>
              null
            )
          ) : (
            ""
          )}
        </div>
      </div>
      {/* DESKTOP & TAB LEFT SECTION ENDS HERE  */}

      {/* MOBILE LEFT SECTION STARTS HERE  */}
      <div className="desktop-hidden" style={{ display: "none" }}>
        <div className="motor-planDetailsMain-mob">
          <div className="produtLogoName-mob">
            <div className="ProductLogoItem-mob">
              <img
                src={`${CDN_URL}takaful_oman_logo.webp`}
                alt="Product Logo Name"
              />
            </div>
            <div className="productName-mob">
              <h1>Takaful Oman</h1>
            </div>
          </div>
          {isClassOpen && (
            <div
              className="productDownArrow-mob"
              onClick={() => {
                gotoSlideDown();
              }}
            >
              <img src={`${CDN_URL}mob_downarrow.webp`} />
            </div>
          )}
          {isProductDetailsOpen && ( // Conditionally render the add button div
            <div className="activeClass">
              <div className="Product-details-mob">
                {policyType === "thirdparty" || isTravel() || isDomestic() ? null : (
                  <div className="plandetails-dts">
                    <div className="plandetails-dts-itm">Vehicle Value</div>
                    <div className="plandetails-dts-itmrs">
                      {orderData?.vehicleDetails?.idv}
                    </div>
                  </div>
                )}
                {/* <div className="form-items">
                          <div className="label-item">Type</div>
                          <div className="value-item">{orderData?.vehicleDetails?.policyType}</div>
                        </div> */}
                {/* <div className="form-items">
                          <div className="label-item">Addon</div>
                          <div className="value-item">13 RO</div>
                        </div> */}
                <div className="plandetails-dts-itmrs text-right"></div>
                {updatedAddons && updatedAddons.length > 0
                  ? updatedAddons?.map((addon) => (
                      <div
                        key={addon?.addonName}
                        className={
                          isArabicLang
                            ? "plandetails-dts rgt-direction"
                            : "plandetails-dts"
                        }
                      >
                        <div
                          className={
                            isArabicLang
                              ? "plandetails-dts-itm"
                              : "plandetails-dts-itm"
                          }
                        >
                          {addon?.addonName}
                        </div>
                        {+addon?.addonTotalPremium > 0 ? (
                          <div
                            className={
                              isArabicLang
                                ? "plandetails-dts-itmrs text-left"
                                : "plandetails-dts-itmrs"
                            }
                          >
                            {/* 2058 (AED) */}
                            RO{" "}
                            {(+addon?.addonTotalPremium).toLocaleString(
                              "en-US",
                              { currency: "USD" }
                            )}
                          </div>
                        ) : null}
                      </div>
                    ))
                  : null}
                <div
                  className={
                    isArabicLang ? "plandetails-dts" : "plandetails-dts"
                  }
                >
                  <div
                    className={
                      isArabicLang
                        ? "plandetails-dts-itm"
                        : "plandetails-dts-itm"
                    }
                  >
                    Tax
                  </div>
                  <div
                    className={
                      isArabicLang
                        ? "plandetails-dts-itmrs text-left"
                        : "plandetails-dts-itmrs"
                    }
                  >
                    {/* 2058 (AED) */}
                    RO{" "}
                    {(+serviceTax)?.toLocaleString("en-US", {
                      // currency: "USD",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </div>
                </div>
              </div>
              <div className="planDetailsPrice-mob">
                <div className="priceLabel">{t("PRICE")}</div>
                <div className="priceResult text-right">178.6 RO</div>
              </div>

              <div
                className="productUpArrow-mob"
                onClick={() => {
                  gotoSlideUp();
                }}
              >
                <img src={`${CDN_URL}up_arrow.webp`} />
              </div>
            </div>
          )}
        </div>
      </div>
      {/* MOBILE LEFT SECTION ENDS HERE  */}
    </>
  );
};

export default PlanDetails;
